import { Pipe, PipeTransform } from '@angular/core';
import dayjs from 'dayjs';
import { DurationUnitsObjectType } from 'dayjs/plugin/duration';

@Pipe({
  name: 'duration'
})
export class DurationPipe implements PipeTransform {

  transform(value: number, initialUnit: keyof DurationUnitsObjectType = 'milliseconds', format = 'HH:mm:ss'): string {
    return dayjs.duration(value, initialUnit).format(format);
  }

}
